/* =========================================================
   SICK BINDER PRODUCT PAGE
   Mobile-safe gallery, variants, stock + personaliser colour
   ========================================================= */

function sbpShowMedia(section, id, direction) {
  if (!section || !id) return;

  section.querySelectorAll('[data-sbp-thumb]').forEach((el) => {
    el.classList.toggle(
      'is-active',
      el.getAttribute('data-media-id') === id
    );
  });

  const mainMedia = section.querySelector('[data-sbp-main-media]');

  section.querySelectorAll('[data-sbp-media]').forEach((el) => {
    const active = el.getAttribute('data-sbp-media') === id;

    el.classList.toggle('is-active', active);
    el.classList.remove(
      'sbp-slide-in-next',
      'sbp-slide-in-prev'
    );

    if (active && direction) {
      void el.offsetWidth;

      el.classList.add(
        direction === 'next'
          ? 'sbp-slide-in-next'
          : 'sbp-slide-in-prev'
      );
    }
  });

  if (mainMedia) {
    mainMedia.dataset.activeMediaId = id;
  }
}


/* =========================================================
   GALLERY NEXT / PREVIOUS
   ========================================================= */

function sbpMoveMedia(section, delta) {
  if (!section) return;

  const items = Array.from(
    section.querySelectorAll('[data-sbp-media]')
  );

  if (items.length < 2) return;

  const currentIndex = Math.max(
    0,
    items.findIndex((el) =>
      el.classList.contains('is-active')
    )
  );

  const nextIndex =
    (currentIndex + delta + items.length) %
    items.length;

  const nextId =
    items[nextIndex].getAttribute('data-sbp-media');

  if (!nextId) return;

  sbpShowMedia(
    section,
    nextId,
    delta > 0 ? 'next' : 'prev'
  );

  const activeThumb = section.querySelector(
    `[data-sbp-thumb][data-media-id="${nextId}"]`
  );

  if (
    activeThumb &&
    window.matchMedia('(max-width:989px)').matches
  ) {
    try {
      activeThumb.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    } catch (_) {
      activeThumb.scrollIntoView();
    }
  }
}


/* =========================================================
   THUMBNAIL CLICK
   ========================================================= */

document.addEventListener('click', function (event) {
  const thumb = event.target.closest(
    '[data-sbp-thumb]'
  );

  if (!thumb) return;

  const section = thumb.closest(
    '[data-sbp-section]'
  );

  const mediaId =
    thumb.getAttribute('data-media-id');

  sbpShowMedia(section, mediaId);
});


/* =========================================================
   VARIANT CHANGE
   Price + media + stock message
   ========================================================= */

document.addEventListener('change', function (event) {
  if (
    !event.target.matches(
      '[data-sbp-variant-select]'
    )
  ) {
    return;
  }

  const select = event.target;

  const section = select.closest(
    '[data-sbp-section]'
  );

  if (!section) return;

  const option =
    select.options[select.selectedIndex];

  if (!option) return;


  /* PRICE */

  const price = section.querySelector(
    '[data-sbp-price]'
  );

  if (
    price &&
    option.dataset.price
  ) {
    price.textContent =
      option.dataset.price;
  }


  /* PRODUCT IMAGE */

  if (option.dataset.mediaId) {
    sbpShowMedia(
      section,
      option.dataset.mediaId
    );
  }


  /* STOCK STATUS */

  const stock = section.querySelector(
    '[data-sbp-stock-status]'
  );

  if (stock) {
    const stockTitle =
      stock.querySelector(
        '[data-sbp-stock-title]'
      );

    const stockText =
      stock.querySelector(
        '[data-sbp-stock-text]'
      );

    const stockQty =
      stock.querySelector(
        '[data-sbp-stock-qty]'
      );

    const state =
      option.dataset.stockState || 'in';

    stock.className =
      `sbp__stock-status sbp__stock-status--${state}`;


    if (option.dataset.stockColor) {
      stock.style.setProperty(
        '--sbp-stock-color',
        option.dataset.stockColor
      );
    }


    if (stockTitle) {
      stockTitle.textContent =
        option.dataset.stockTitle || '';
    }


    if (stockText) {
      stockText.textContent =
        option.dataset.stockText || '';

      stockText.hidden =
        !option.dataset.stockText;
    }


    if (stockQty) {
      const qty = Number(
        option.dataset.stockQuantity || 0
      );

      const managed =
        option.dataset.stockManaged === 'true';

      const showQty =
        option.dataset.showStockQuantity === 'true';

      if (
        showQty &&
        managed &&
        qty > 0
      ) {
        stockQty.textContent =
          `${qty} in stock`;

        stockQty.hidden = false;
      } else {
        stockQty.textContent = '';
        stockQty.hidden = true;
      }
    }
  }


  /* UPDATE URL */

  try {
    const url =
      new URL(window.location.href);

    url.searchParams.set(
      'variant',
      option.value
    );

    window.history.replaceState(
      {},
      '',
      url.toString()
    );
  } catch (_) {}


  /* CUSTOM EVENT */

  document.dispatchEvent(
    new CustomEvent(
      'sbp:variant-change',
      {
        detail: {
          variantId: option.value
        }
      }
    )
  );
});


/* =========================================================
   MOBILE SWIPE GALLERY
   ========================================================= */

function sbpInitSwipe(root = document) {
  const sections =
    root.matches &&
    root.matches('[data-sbp-section]')
      ? [root]
      : Array.from(
          root.querySelectorAll
            ? root.querySelectorAll(
                '[data-sbp-section]'
              )
            : []
        );

  sections.forEach((section) => {
    const gallery =
      section.querySelector(
        '[data-sbp-main-media]'
      );

    if (!gallery) return;

    if (
      gallery.dataset.sbpSwipeReady ===
      'true'
    ) {
      return;
    }

    gallery.dataset.sbpSwipeReady =
      'true';


    let startX = 0;
    let startY = 0;
    let startTime = 0;
    let tracking = false;


    gallery.addEventListener(
      'touchstart',
      (event) => {
        if (
          !event.touches ||
          event.touches.length !== 1
        ) {
          return;
        }

        if (
          event.target.closest(
            'video,iframe,model-viewer,button,a,input,select,textarea'
          )
        ) {
          return;
        }

        const touch =
          event.touches[0];

        startX = touch.clientX;
        startY = touch.clientY;
        startTime = Date.now();
        tracking = true;
      },
      {
        passive: true
      }
    );


    gallery.addEventListener(
      'touchend',
      (event) => {
        if (!tracking) return;

        tracking = false;

        if (
          !event.changedTouches ||
          event.changedTouches.length !== 1
        ) {
          return;
        }

        const touch =
          event.changedTouches[0];

        const dx =
          touch.clientX - startX;

        const dy =
          touch.clientY - startY;

        const elapsed =
          Date.now() - startTime;


        /* Ignore short taps */

        if (Math.abs(dx) < 42) {
          return;
        }


        /* Ignore mostly vertical gestures */

        if (
          Math.abs(dx) <=
          Math.abs(dy) * 1.15
        ) {
          return;
        }


        /* Ignore very slow gestures */

        if (elapsed > 900) {
          return;
        }


        sbpMoveMedia(
          section,
          dx < 0 ? 1 : -1
        );
      },
      {
        passive: true
      }
    );
  });
}


/* =========================================================
   LIGHTWEIGHT PERSONALISER BUTTON COLOUR
   No MutationObserver
   No recursive DOM scanning
   No iframe scanning
   ========================================================= */

function sbpPaintPersonalizerButton(section) {
  if (!section) return;

  if (
    section.dataset
      .sbpSyncPersonalizer !== 'true'
  ) {
    return;
  }

  const container =
    section.querySelector(
      '.sbp__personalizer-app'
    );

  if (!container) return;


  const styles =
    getComputedStyle(section);

  const bg =
    styles
      .getPropertyValue('--sbp-cta-bg')
      .trim();

  const fg =
    styles
      .getPropertyValue('--sbp-cta-text')
      .trim() || '#ffffff';

  if (!bg) return;


  const buttons =
    container.querySelectorAll(
      'button,input[type="submit"],a,[role="button"]'
    );


  buttons.forEach((el) => {
    const label = String(
      el.textContent ||
      el.value ||
      el.getAttribute('aria-label') ||
      ''
    )
      .trim()
      .toLowerCase();


    const testId = String(
      el.getAttribute('data-testid') ||
      ''
    )
      .trim()
      .toLowerCase();


    const isPersonalizerButton =
      testId ===
        'standalone-add-to-cart' ||
      /customi[sz]e\s+your\s+binder/.test(
        label
      );


    if (!isPersonalizerButton) {
      return;
    }


    el.style.setProperty(
      'background-color',
      bg,
      'important'
    );

    el.style.setProperty(
      'border-color',
      bg,
      'important'
    );

    el.style.setProperty(
      'color',
      fg,
      'important'
    );


    el.querySelectorAll(
      'span,strong'
    ).forEach((child) => {
      child.style.setProperty(
        'color',
        fg,
        'important'
      );
    });
  });
}


/* =========================================================
   PERSONALISER INITIALISATION

   Check a few times while the app hydrates,
   then stop completely.
   ========================================================= */

function sbpInitPersonalizerColour(
  root = document
) {
  const sections =
    root.matches &&
    root.matches('[data-sbp-section]')
      ? [root]
      : Array.from(
          root.querySelectorAll
            ? root.querySelectorAll(
                '[data-sbp-section]'
              )
            : []
        );


  sections.forEach((section) => {
    const delays = [
      0,
      250,
      700,
      1400,
      2500
    ];


    delays.forEach((delay) => {
      window.setTimeout(() => {
        sbpPaintPersonalizerButton(
          section
        );
      }, delay);
    });
  });
}


/* =========================================================
   INITIAL PAGE LOAD
   ========================================================= */

function sbpInitProductPage(
  root = document
) {
  sbpInitSwipe(root);

  sbpInitPersonalizerColour(
    root
  );
}


if (
  document.readyState === 'loading'
) {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      sbpInitProductPage();
    },
    {
      once: true
    }
  );
} else {
  sbpInitProductPage();
}


/* =========================================================
   SHOPIFY THEME EDITOR
   ========================================================= */

document.addEventListener(
  'shopify:section:load',
  (event) => {
    sbpInitProductPage(
      event.target
    );
  }
);